const isUsableAvatar = (value) => {
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase();
  return normalized !== "" && normalized !== "null" && normalized !== "undefined";
};

export const resolveAvatarSrc = ({
  uploadedImg,
  userProfilePic,
  contextProfilePic,
  dummyImg,
  mode = "default",
}) => {
  if (isUsableAvatar(uploadedImg)) return uploadedImg;
  if (mode === "create") return dummyImg;
  if (isUsableAvatar(userProfilePic)) return userProfilePic;
  if (isUsableAvatar(contextProfilePic)) return contextProfilePic;
  return dummyImg;
};
